export default __webpack_public_path__ + "static/media/hazard_map.7e38cbad.jpg";